// =================================================================
// custom.js
// Contiene la lógica externa de Isotope
// =================================================================

// Variable global para almacenar la instancia de Isotope
let isotopeInstance = null;

/**
 * 1. Inicializa Isotope en un contenedor dado.
 * Debe llamarse solo una vez.
 * @param {string} selector - Selector jQuery para el contenedor del grid (ej: ".isotope-grid-container").
 */
export function initializeIsotopeGrid(selector=".masonry-outer") {
/*     if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.isotope) {
        console.error("jQuery o Isotope no están cargados. No se puede inicializar el grid.");
        return;
    } */

     const $grid = window.jQuery(selector);

     console.info($grid);

    if ($grid.length === 0) {
        console.warn(`Contenedor Isotope no encontrado con el selector: ${selector}`);
        return;
    }
    
    const isotopeInstance = window.jQuery(selector);
    // Si ya está inicializado, lo destruimos primero (útil si hay recargas)
    if (isotopeInstance) {
        isotopeInstance.destroy();
        isotopeInstance = null;
    }

    // Inicialización
    isotopeInstance = $grid.isotope({
					itemSelector: '.masonry-item',
					transitionDuration: '1s',
					originLeft: true,
					stamp: '.stamp',
    });

    $grid.imagesLoaded().progress( function() {
        $grid.isotope('layout');
    });   
    
    var $container =  window.jQuery('.masonry-outer').isotope('reloadItems').isotope({ sortBy: 'original-order' });

    $container.imagesLoaded().progress( function() {
        $container.isotope('layout');
    })     
 
    
    console.log("Isotope Grid inicializado.");
}

/**
 * 2. Aplica el filtrado a la instancia de Isotope con los datos del formulario.
 * @param {Object} filterData - Objeto con los datos del formulario (ej: { nombre: '...', centropenal: '...' }).
 */
export function applyIsotopeFilter(filterData) {
/*     if (!isotopeInstance) {
        console.warn("Isotope no está inicializado. Llamar a initializeIsotopeGrid primero.");
        return;
    } */
    const isotopeInstance = window.$('.masonry-outer');
    //console.info(isotopeInstance);
    const { nombre, centropenal, departamento } = filterData;
    let nombreRegex = null;
    if (nombre) {
        // 'i' para insensibilidad a mayúsculas/minúsculas.
        // Se usa una expresión regular para manejar búsqueda parcial y segura.
        try {
            nombreRegex = new RegExp(nombre.trim(), 'i');
        } catch (e) {
            console.error("Expresión regular inválida para Nombre:", e);
        }
    }
    
    // b) Normalizar valores para Selects (comparación exacta, sin RegExp)
    const centroLower = centropenal ? centropenal.toLowerCase().trim() : '';
    const deptoLower = departamento ? departamento.toLowerCase().trim() : '';

    // Si todos los campos están vacíos, mostramos todos los ítems
    if (!nombreRegex && !centroLower && !deptoLower) {
        isotopeInstance.isotope({ filter: '*' });
        console.log("Todos los campos están vacíos. Mostrando todos los ítems.");
        console.log(filterData);
        return;
    }

    // 2. Función de Filtrado de Isotope
    const filterFunction = (index, element) => {
        const $element = window.$(element); 

        // Leer los datos del DOM (atributos data-*) y normalizar
        const itemNombre = $element.data('nombre') ? String($element.data('nombre')) : '';
        const itemCentroPenal = $element.data('centropenal') ? $element.data('centropenal').toLowerCase().trim() : '';
        const itemDepartamento = $element.data('departamento') ? $element.data('departamento').toLowerCase().trim() : '';
        
        // ===================================================================
        // LÓGICA DE BÚSQUEDA
        // ===================================================================
        
        // 1. matchNombre (Con Expresión Regular)
        // Es TRUE si nombreRegex es nulo (campo vacío), O si la RegExp prueba el ítem.
        const matchNombre = !nombreRegex || nombreRegex.test(itemNombre);
        
        // 2. matchCentro (Comparación exacta)
        // Es TRUE si centroLower está vacío, O si el valor coincide.
        const matchCentro = !centroLower || itemCentroPenal === centroLower;
        
        // 3. matchDepto (Comparación exacta)
        // Es TRUE si deptoLower está vacío, O si el valor coincide.
        const matchDepto = !deptoLower || itemDepartamento === deptoLower;

        // El ítem se muestra si cumple con TODAS las condiciones
        return matchNombre && matchCentro && matchDepto;

    };

    // Aplicar el filtro a Isotope
    isotopeInstance.isotope({ filter: filterFunction });
    console.log("Filtro aplicado con datos:", filterData);
}

/**
 * 3. Expone una función para destruir la instancia de Isotope
 */
export function destroyIsotopeGridUNsed() {
    if (isotopeInstance) {
        isotopeInstance.destroy();
        isotopeInstance = null;
        console.log("Isotope Grid destruido.");
    }
}

/**
 * Recarga y re-calcula el diseño de Isotope.
 */
export function refreshIsotopeLayout(selector) {
    const $grid = window.jQuery(selector);
    if ($grid) {
        // reloadItems informa a Isotope sobre los nuevos/actualizados elementos DOM
        // layout recalcula la posición
        $grid.isotope('reloadItems').isotope('layout');
        console.log("Isotope: Layout refrescado.");
    }
}
// 